import { IViolation, IAttribute } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { ParameterConfig } from 'app/model/pipeline/parameter-config';
import { TabularCopySource } from 'app/model/pipeline/copysource/tabular-type.copysource';
import { createParameterConfigurationValidator } from 'app/model/adapters/linkedservices/parameter-config.util';
import { stringIsNullOrEmpty } from '../../../shared/utils/string.util';

@Metamodel.model({
    abstract: true
})
export abstract class SqlTypeCopySource extends TabularCopySource {
    public static readonly READER_STORED_PROCEDURE_NAME: IAttribute;
    public static readonly READER_STORED_PROCEDURE_PARAMETERS: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'READER_STORED_PROCEDURE_NAME',
        display: stringResources.Dataset_ReaderStoredProcedureName,
        constraint: {
            validator: SqlTypeCopySource.validateReaderStoredProcedure
        },
        bypassExpressionValidation: (source: SqlTypeCopySource) => {
            return source.mode !== 'storedProcedure';
        }
    })
    public readerStoredProcedureName?: string;

    @Metamodel.attribute({
        display: stringResources.Dataset_ReaderStoredProcedureParameters,
        constraint: {
            validator: createParameterConfigurationValidator(true)
        },
        accepts: ['Object', 'Array'],
        association: 'READER_STORED_PROCEDURE_PARAMETERS'
    })
    public readerStoredProcedureParameters?: ParameterConfig[] = [];

    private static validateReaderStoredProcedure(sqlTypeCopySource: SqlTypeCopySource, storedProcedureName?: string): IViolation[] | undefined {
        if (sqlTypeCopySource.mode === 'storedProcedure' && stringIsNullOrEmpty(storedProcedureName)) {
            return [
                {
                    message: () => stringResources.SourceActivity_SourceTab_StoredProcedureMissingErrorMessage
                }
            ];
        }
        return undefined;
    }
}
